var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"permission-set"},[_c('span',{staticClass:"permission-set__header"},[_vm._v(" "+_vm._s(_vm.data.groupName)+" ")]),_c('span',{staticClass:"permission-set__content"},[_vm._v(" "+_vm._s(_vm.data.permissionName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }